export const SINAN_DESEASES = [
    {label: "Dengue", value:"DENGUE"},
    {label: "Covid", value:"COVID"}
]